import React, { useEffect } from 'react';
import Hero from './components/Hero';
import ProblemStatement from './components/ProblemStatement';
import HintSection from './components/HintSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    document.title = "HELM | Reclaim Your Attention";
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <main className="min-h-screen bg-dark text-white overflow-hidden">
      <Hero />
      <ProblemStatement />
      <HintSection />
      <Footer />
    </main>
  );
}

export default App;